module.exports = __webpack_public_path__ + "static/media/guide_mobile_04.d4aaf622.svg";